(function () {
  window.Shopify = window.Shopify || {};

  if (typeof window.Shopify.formatMoney === 'function') return;

  window.Shopify.formatMoney = function (cents, format) {
    const amount = (Number(cents) / 100).toFixed(2);
    const template = format || '€{{amount_with_comma_separator}}';

    return template
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amount.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  };
})();
